// import { h } from "vue";
import type { IconSet, IconProps } from 'vuetify';

const icons = import.meta.glob('./*.vue', { eager: true });

/**
 * Converts a string to camelCase.
 *
 * @param {string} str - The string to be converted.
 * @returns {string} - The camelCase version of the input string.
 */
function camelize(str: string): string {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

const customSvgNameToComponent: Record<string, string> = Object.fromEntries(
  Object.entries(icons).map(([path, component]: any) => {
    const fileName = path.split('/').pop()?.replace('.vue', '');
    const camelCaseName = fileName ? camelize(fileName) : '';
    return [camelCaseName, component.default];
  })
);

const customIcons: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon as string]),
};

export { customIcons };
